<template>
    <div class="card">
        <DataTable
            :value="allDataSources"
            :lazy="true"
            :resizableColumns="true"
            ref="dt"
            data-key="id"
            :rowHover="true"
            paginator
            :rows="10"
            selectionMode="single"
            :loading="loading"
            :totalRecords="totalDataSources"
            responsiveLayout="scroll"
            :rowsPerPageOptions="[2, 5, 10, 20, 50]"
            paginatorTemplate="CurrentPageReport JumpToPageInput FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries :: Page No:"
            @page="onPage"
        >
            <template #empty>No datasources available.</template>
            <template #loading>Loading DataSources. Please wait.</template>
            <Column field="id" header="ID" style="max-width: 4rem" />
            <Column field="name" header="NAME" style="width: 8rem" />
            <Column field="code" header="CODE" style="width: 8rem" />
            <Column field="description" header="DESCRIPTION" style="max-width: 14rem" />
            <Column field="default" header="USER GROUPS" style="width: 6rem"  bodyClass="text-center">
                <!-- used_by_metrics -->
                <template #body="slotProps">
                    <tag v-if="slotProps.data.used_by_user_groups.length > 0" icon="pi pi-user" severity="secondary" :value="slotProps.data.used_by_user_groups.length" rounded v-tooltip="`Number of User Groups created using this Datasource`" />
                </template>
            </Column>
            <Column field="default" header="METRICS" style="width: 6rem" bodyClass="text-center">
                <!-- used_by_metrics -->
                <template #body="slotProps">
                    <tag v-if="slotProps.data.used_by_metrics.length > 0" icon="pi pi-chart-line" severity="secondary" :value="slotProps.data.used_by_metrics.length" rounded v-tooltip="`Number of Metrics created using this Datasource`"/>
                </template>
            </Column>
            <Column field="public" header="USER GROUP ONLY" style="width: 8rem">
                <template #body="slotProps">
                    <Tag :severity="slotProps.data.user_group_only ? 'info' : 'danger'" :value="slotProps.data.user_group_only ? 'True' : 'False'" rounded />
                </template>
            </Column>
            <Column field="public" header="SHARED" style="width: 8rem">
                <template #body="slotProps">
                    <Tag :severity="slotProps.data.public ? 'info' : 'danger'" :value="slotProps.data.public ? 'True' : 'False'" rounded />
                </template>
            </Column>
            <!-- <Column field="author_id" header="AUTHOR" style="width: 8rem" /> -->
            <Column field="created_at" header="CREATED AT" style="width: 8rem">
                <!--formatDate-->
                <template #body="slotProps">
                   {{formatDate(slotProps.data.created_at)}}
                </template>
            </Column>
            <Column field="actions" header="ACTIONS" style="width: 16rem">
                <template #body="slotProps">

                    <!-- @click="operate(slotProps.data, 'view')" -->
                    <Button icon="pi pi-eye" class="p-button-rounded p-button-info mr-2" v-tooltip="'View DataSource Details'" />
                    <Button icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2" @click="configureLinks(slotProps.data.id)" v-tooltip="'Edit DataSource'" />
                    <Button v-if="slotProps.data.deletable" icon="pi pi-trash" class="p-button-rounded p-button-danger mr-2" @click="confirmDelete(slotProps.data.id)" v-tooltip="'Delete DataSource'" />
                    <Button v-else disabled icon="pi pi-trash" class="p-button-rounded p-button-danger mr-2" v-tooltip="'There is a user group or metric linked to this datasource'" />
                </template>
            </Column>
        </DataTable>
    </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
const store = useStore();

import GlobalRequest from '@/api/global-request';
import { useStore } from 'vuex';
import { formatDate } from '@fullcalendar/common';
import { showToast } from '@/helpers/toast-handler';
import { useConfirm } from 'primevue/useconfirm';
const confirm = useConfirm();

const router = useRouter();

const loading = ref(false);
const totalDataSources = ref(0);
const paginationRows = ref(10)
const paginationPage = ref(1)
const allDataSources = ref([])

const company_id = computed(() => {
    return store.getters['auth/userCompanyId']?.id;
});

onMounted(() => {
    loadDataSources();
})

const onPage = async (event) => {
    paginationRows.value = event.rows;
    //Table data pages start with 0 not with 1.
    paginationPage.value = event.page + 1;

    loadDataSources();
};

const confirmDelete = (id) => {
    confirm.require({
        message: 'Are you sure you want to delete Datasource ' + id + '?',
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        accept: async () => {
            loading.value = true;
            GlobalRequest.deleteRequest('v2/datasource/'+id, {
                params: {
                    company_id: company_id.value,
                },
            }).then(() => {
                loadDataSources();
            });
        },
        reject: () => {
            showToast({ summary: 'Rejected' }, 'Datasource not deleted');
        },
    });
};

const loadDataSources = async () => {
    loading.value = true;
    GlobalRequest.getRequest('v2/datasource', {
        params: {
            company_id: company_id.value,
            page_size: paginationRows.value,
            page: paginationPage.value,
            paginate: true,
            execute: true,
        },
    }).then((response) => {
        allDataSources.value = response.data.data;
        totalDataSources.value = response.data.total
    }).then(() => {
        loading.value = false;
    });
};

const configureLinks = (id) => {
    router.push({ name: 'DataSourceUpdate', params: { id } });
};
</script>
